import MobileDevice from './MobileDeviceInfo';
export default MobileDevice;